import React from 'react'
import { Heading, Link } from 'base-ui'
import Highlighter from './Highlight'
import { Link as LinkExample } from '../examples/Link'
import { PageWrapper } from './PageWrapper'

const LinkPage = () => {
  return (
    <PageWrapper title="Links">
      <Heading size="h3">Variants</Heading>
      <Link color="default" href="#" target="_blank" download={false} size="md" className="py-2 pr-8">Default link</Link>
      <Link color="primary" href="#" target="_blank" download={false} size="md" className="py-2 pr-8">Primary link</Link>
      <Link color="hint" href="#" target="_blank" download={false} size="md" className="py-2 pr-8">Hint link</Link>

      <Heading size="h3">Sizes</Heading>
      <Link color="default" href="#" target="_blank" download={false} size="sm" className="py-2 pr-8">Default sm link</Link>
      <Link color="default" href="#" target="_blank" download={false} size="md" className="py-2 pr-8">Default md link</Link>
      <Link color="default" href="#" target="_self" download={false} size="lg" className="py-2 pr-8">Default lg link</Link>

      <Heading size="h3">Download</Heading>
      <Link color="default" href="#" target="_self" download={true} size="md" className="py-2 pr-8">Default link</Link>
      
      <Heading size="h3">Usage</Heading>
      <div className="py-4">
        <Highlighter code={LinkExample} language='jsx' />
      </div>
    </PageWrapper>
  )
}

export default LinkPage
